<app-custom-requisition-form
	[selectedRequisitionId]="selectedRequisitionId_()"
	(onSubmit)="onSubmit.emit($event)"
	(formStatusChange)="onFormStatusChange.emit($event)"
>
	<div header-content class="flex flex-col">
		<h3>Create Custom Requisition</h3>
		<p>Create a Custom Requisition from an existing requisition template</p>
	</div>

	<ng-container footer-content>
		<ui-button
			preset="MEDIUM_EMPHASIS"
			(click)="onSecondaryButtonClick.emit()"
			[label]="secondaryButtonLabel_()"
			[testHook]="testHooks.SecondaryLabelButton"
		/>
		<ui-button
			preset="HIGH_EMPHASIS"
			type="submit"
			[disabled]="isDisabled_()"
			[loading]="loading_()"
			label="Create"
			[testHook]="testHooks.CreateButton"
		/>
	</ng-container>
</app-custom-requisition-form>
